// アンケート送信完了の記録 (spec: docs/superpowers/specs/2026-07-26-survey-completion-screen-design.md §4)。
//
// sessionStorage に置くのは意図的な選択 (spec D5)。localStorage だと週次アンケートなのに、
// 一度答えた人が翌週 URL を開いても完了画面に着地して二度と回答できなくなる。
// sessionStorage なら「リロードは耐え、タブを閉じれば消える」で必要な範囲だけを満たす。
//
// キーに surveyId を含めないのも意図的 (spec §4.1)。App は survey をロードする前に復元判定を
// するため、キーを引くのに survey のロードを待てない。将来複数アンケートを並べるときの
// 照合用に、surveyId はレコード側が持つ。

export type CompletionRecord = {
  surveyId: string;
  answered: number;
  total: number;
  completedAt: string; // ISO 8601
};

const KEY = "audio-form:completed";

export function saveCompletion(record: CompletionRecord): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(record));
  } catch {
    // QuotaExceeded / SecurityError 等は静かに無視 (原則 5: 記録できなくても画面は進む)
  }
}

export function loadCompletion(): CompletionRecord | null {
  let raw: string | null;
  try {
    raw = sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
  if (!raw) return null;
  try {
    const parsed: unknown = JSON.parse(raw);
    return isValidRecord(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function clearCompletion(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // 同上
  }
}

// 壊れた記録で「6 問中 9 問に回答」のような表示が出るのを防ぐ (spec §4.2)。
// 不正なら null に倒れ、通常の事前チェックから始まるだけなので詰まらない。
function isValidRecord(value: unknown): value is CompletionRecord {
  if (typeof value !== "object" || value === null) return false;
  const r = value as Record<string, unknown>;
  if (typeof r.surveyId !== "string" || r.surveyId === "") return false;
  if (typeof r.completedAt !== "string") return false;
  if (!Number.isInteger(r.answered) || !Number.isInteger(r.total)) return false;
  const answered = r.answered as number;
  const total = r.total as number;
  return total > 0 && answered >= 0 && answered <= total;
}
